module.exports = __webpack_public_path__ + "static/img/13.192ee05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppt/13.jpg
// module id = heAp
// module chunks = 1